import * as React from 'react';
import _ from 'lodash'
declare const I18n;

type Props = {
  cardBackground: "primary" | "secondary" 
  title: string,
  description?: string,
  targetRole?: string,
  index: number,
  id: number,
  image?: string,
  isFacilitator?: boolean,
  isLearner?: boolean,
  handleDelete?(id: number): void,
  type?: string,
  duration?: string,
  category?: string,
}

const CategoryCard: React.FunctionComponent<Props> = ({
  cardBackground = "primary",
  title,
  targetRole,
  index,
  id,
  handleDelete,
  image,
  isFacilitator,
  isLearner,
  type = 'learn more',
  duration,
  category = 'Video',
  description = ''
}: Props): JSX.Element => {
  const mod = index % 3;
  let levelText = `${_.capitalize(targetRole)}`;

  const isAdmin = !(isLearner || isFacilitator);

  const imageNode = (
    <div className={`card-list-item__image-container`}>
    {
      image ? (
        <div className="card-list-item__image card-list-item__image--background" style={{ backgroundImage: `url(${image})` }} />
      ) : (
        <div className="empty-resource-container">
       </div>
      )
    }
    </div>
  );

  const cardType = (
    <div className="type">
      <i className={
        type === 'pdf' ? 'fa-solid fa-file-pdf icon' :
        type === 'link' ? 'fa-solid fa-link icon' :
        type === 'youtube' ? 'fa-brands fa-youtube icon' :
        type === 'post' ? 'fa-solid fa-newspaper icon' :
        type === "learn more" ? 'fa-solid fa-magnifying-glass icon' :
        'fa-solid fa-file icon'
      }></i>
      {I18n.t('models.resource.attributes.learn_more')}
    </div>
  );

  return (
    <div
      className={`card-list-item ${cardBackground}`}
      style={{
        marginRight: (mod === 0 || mod === 1) ? '1.2%' : 0,
        marginLeft: (mod === 1 || mod === 2) ? '1.2%' : 0
      }}
    >
      <a
        style={{ cursor: 'pointer', textDecoration: 'none', borderRadius: '20px'}}
        href={`${isAdmin ? '/admin' : ''}/explore_categories/${id}/resources`}
      >
        {imageNode}
      </a>
      <div className="card-list-item__meta-container">
        <div>
          <div className="card-list-item__title-container">
            {/* Sub information */}
            <div id={`resource_category_title_${id}`} className="card-list-item__title">{title}</div>
            {isAdmin && (
              <div className="card-list-item__admin-container">
                <a href={`/admin/explore_categories/${id}/edit`} aria-label={I18n.t('views.common.edit')}>
                  <i className="fal fa-edit card-list-item__icon--admin" />
                </a>
                <button
                  type="button"
                  id={`delete_${id}`}
                  className="btn btn-link p-0 m-0 align-baseline"
                  onClick={(e) => { e.preventDefault(); if (confirm(I18n.t('views.common.confirm_delete'))) handleDelete?.(id); }}
                  aria-label={I18n.t('views.common.delete')}
                >
                  <i className="fal fa-trash card-list-item__icon--admin" />
                </button>
              </div>
            )}
          </div>
          <div className="card-list-item__desc-container">
            <div id={`resource_category_description_${id}`} className="card-list-item__description">{description.substring(0, 80)}</div>
          </div>
        </div>
        <a
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          href={`${isAdmin ? '/admin' : ''}/explore_categories/${id}/resources`}
          className={'btn btn-sm btn-primary'}
        >
          {type && cardType}
        </a>
      </div>
    </div>
  );
}

export default CategoryCard;
